/** Only recording companions, never ExportIndex.csv or arbitrary clinical CSVs. */
export function vogRecordingGuid(filename: string | undefined, kind: "pgm" | "mat" | "calibrated"): string | undefined {
  const match =
    /^[^/\\\r\n\0]+_G_([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})_(rec\.(pgm|mat)|calibrated\.csv)$/i.exec(
      filename ?? "",
    );
  const actual = match?.[3]?.toLowerCase() ?? (match ? "calibrated" : undefined);
  return actual === kind ? match?.[1]?.toLowerCase() : undefined;
}

/** The EyeSeeCam protocol id in a recording filename, e.g. `head-impulse` or `nystagmus.optokinetic`. */
export function vogProtocol(filename: string | undefined): string | undefined {
  return /_PR_de\.eyeseetec\.protocol\.([a-z0-9.-]+)_VA_/i.exec(filename ?? "")?.[1]?.toLowerCase();
}
